/**
 * How long a client must wait after a work-order mutation before reading the
 * numbers it moved.
 *
 * Several work-order state changes are applied by ASYNC listeners AFTER the
 * request that triggered them has already returned:
 *
 *  - Department routing on create.
 *  - The auto-close when the last service is completed. The completion
 *    response carries `navigation_hint: 'close'`, but that is a PREDICTION —
 *    WorkOrderService.CompleteServiceWithResult computes it by querying the
 *    remaining services "synchronously instead of waiting for the async
 *    listener". The row is still `in_progress` when the client gets that hint;
 *    ServiceCompletionDepartmentTransitionListener writes
 *    `state='closed', end_date=NOW()` a moment later.
 *
 * So a refetch fired the instant a completion returns reads the PRE-close
 * state, and the dashboard's closed-today count looks exactly like it "did not
 * update". The listeners settle within ~500ms; 700ms keeps a safety margin
 * without feeling slow.
 *
 * Shared by web (utils/workOrderEvents) and mobile (queries/workOrderRefresh)
 * so the two platforms cannot disagree about how long the backend needs.
 */
export const WORK_ORDER_SETTLE_MS = 700;
